import { VideoMediaCenterMenuBaseColumn } from './video-media-center-menu-base-column'

import { PLUGIN_NAME } from './plugin-name'

const MenuItem = global.videojs.getComponent('MenuItem')

/**
 * @class
 * @extends VideoMediaCenterMenuBaseColumn
 */
// eslint-disable-next-line import/prefer-default-export
export class VideoMediaCenterMenuAudioColumn extends VideoMediaCenterMenuBaseColumn {
  #pluginAPI

  #title

  /**
   * @param {Player|Object} player
   * @param {Object} [options]
   * @returns {void}
   */
  constructor (player, options) {
    super(player, options)

    /** @type  {import('./video-media-center-plugin').VideoMediaCenterPlugin} */
    this.#pluginAPI = this.player()[PLUGIN_NAME]()

    /** @type {string} */
    this.#title = 'audio'
    this.addTitle(this.#title)

    const items = this.#getItems()
    this.addItems(items)
  }

  /**
   * generate audio tracks menu items
   * @returns {MenuItem[]}
   */
  #getItems () {
    const audioTracks = this.#pluginAPI.getAudioTracks()
    const restoredActiveAudioTrack = this.#pluginAPI.getRestoredActiveAudioTrack()

    const menuItems = audioTracks.map((item) => {
      const menuItemOptions = {
        selectable: true,
        multiSelectable: false,
        value: item,
        label: this.#pluginAPI.getLanguageLabel(item),
        selected: item === restoredActiveAudioTrack,
        // key: item
      }
      return new MenuItem(this.player(), menuItemOptions)
    })
    return menuItems
  }

  /**
   * get selected child
   * @returns {MenuItem}
   */
  #getSelectedItem () {
    const selectedItem = this.children().find(
      (childCmt) => childCmt.isSelected_,
    )
    return selectedItem
  }

  /**
   * extend super.handleTapClick:
   * 1. Radio-button mode
   * 2. Run side-effects by trigger event
   *
   * @param {Object} event
   * @returns {void}
   */
  handleTapClick (event) {
    // TODO replace with 'super.handleTapClick(event)' after updating the babel preset env
    Reflect.getPrototypeOf(
      VideoMediaCenterMenuAudioColumn.prototype,
    ).handleTapClick.call(this, event)

    const target = event.type === 'tap' ? event.target : event.currentTarget

    this.children().forEach((childCmt) => {
      if (childCmt.el() !== target) {
        childCmt.selected(false)
      }
    })

    const selectedItem = this.#getSelectedItem()

    if (selectedItem !== undefined) {
      this.#pluginAPI.onAudioLanguageChanged(selectedItem.options_.value)
    }
  }
}
